import { render, staticRenderFns } from "./ClassificationForm.vue?vue&type=template&id=29f37e0d&"
import script from "./ClassificationForm.vue?vue&type=script&lang=ts&"
export * from "./ClassificationForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports